import { SurveyQuestion_FreeText, SurveyQuestion_Scale } from './types.js';
const SurveyQuestion1_ID = '24285da7f5fb42c2ba138950bcb0c37d';
const Question1 = {
    _id: SurveyQuestion1_ID,
    label: 'Is the application easy to use?',
    inputType: SurveyQuestion_Scale
};
const SurveyQuestion2_ID = 'f3217df91064a37902ccd1abd4300eac';
const Question2 = {
    _id: SurveyQuestion2_ID,
    label: 'Did the application save you time?',
    inputType: SurveyQuestion_Scale
};
const SurveyQuestion3_ID = '003d2b20dc94003932777887904583e2';
const Question3 = {
    _id: SurveyQuestion3_ID,
    label: 'Did the application help you make better clinical decisions?',
    inputType: SurveyQuestion_Scale
};
const SurveyQuestion4_ID = '23b71bb5434611f0d91deb4c2a47ac27';
const Question4 = {
    _id: SurveyQuestion4_ID,
    label: 'Would you recommend the application to your colleagues?',
    inputType: SurveyQuestion_Scale
};
const SurveyQuestion5_ID = '2e97ab7c1950ddf2eaa0dbe39ece468d';
const Question5 = {
    _id: SurveyQuestion5_ID,
    label: 'Any additional comments or suggestions for improvement?',
    inputType: SurveyQuestion_FreeText
};
export const EndEncounterSurvey = {
    label: 'Rate your experience',
    description: 'Share your feedback and help us better the Quai.MD experience',
    components: [Question1, Question2, Question3, Question4, Question5]
};
//# sourceMappingURL=consts.js.map